import * as server from '../entries/pages/player/_id_/_page.server.js';

export const index = 11;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/player/_id_/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/player/[id]/+page.server.js";
export const imports = ["_app/immutable/nodes/11.Q3udGliQ.js","_app/immutable/chunks/scheduler.XyTI1WgU.js","_app/immutable/chunks/index.HYtw-Ape.js","_app/immutable/chunks/each.ru6HoQ3H.js","_app/immutable/chunks/stores.cmjOqmRh.js","_app/immutable/chunks/entry.JOuTWzBz.js","_app/immutable/chunks/index.QwWjWMOQ.js","_app/immutable/chunks/SvelteImg.iqmTAVve.js","_app/immutable/chunks/spread.rEx3vLA9.js"];
export const stylesheets = ["_app/immutable/assets/11.z_PksthK.css"];
export const fonts = [];
